import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { LearnProgressChart } from 'src/components/Home/Header/LearnProgressChart/LearnProgressChart';
import { ConvertURL } from 'src/components/Layout/Header/ConvertURL';
import useUser from 'src/hook/data/useUser';
import { useBackHandler } from 'src/hook/global/useBackHandler';
import { useIFrameModal } from 'src/hook/modal/useIFrameModal';
import { ChevronType, DarkMode, PathName } from 'src/model/enum/enums';
import { GetRazorSiteUrl, IconLocation } from 'src/utils/URLUtils';
import { Chevron } from '../../Features/Chevron/Chevron';
import UpgradeButton from '../UpgradeButton/UpgradeButton';
import styles from './PageHeader.module.scss';

interface PageHeaderProps {
    title?: string;
    backUrl?: string;
    handleBackClick?: () => void;
    forceUrl?: boolean;
    backgroundColor?: string;
}

export const PageHeader = ({ title, backUrl, handleBackClick,
    forceUrl, backgroundColor }: PageHeaderProps) => {
    const { t, i18n } = useTranslation();
    const handleBack = useBackHandler();
    const location = useLocation();
    const { userInfo } = useUser();
    const { open } = useIFrameModal();

    const defaultBackgroundColor = userInfo?.DarkMode === DarkMode.Dark ? '#121212' : '#EFF2F8';
    const back = () => {
        if (handleBackClick) {
            handleBackClick();
        }
        else if (location.pathname.split('/').length === 2) {
            handleBack('/', true)
        }
        else {
            handleBack(backUrl, forceUrl);
        }
    }
    return (
        <header className={styles.pageHeader} style={{ backgroundColor: backgroundColor || defaultBackgroundColor }}>
            <Chevron type={ChevronType.Left} onClick={back} size={30} />
            <h1 dir={i18n.dir()}>{t(title || ConvertURL(location.pathname))}</h1>
            {location.pathname === PathName.wordlists &&
                <img className={styles.logo} onClick={() => open(GetRazorSiteUrl('discover/word-list-fullmap', userInfo?.Token), t('Full knowledge map'))}
                    src={IconLocation('idiomslogo')} alt="Logo" />}

            {location.pathname === PathName.learn
                && <LearnProgressChart />}
            {(location.pathname === PathName.search ||
                location.pathname === PathName.lessons)
                && <UpgradeButton />}
        </header>
    );
};
